<template>
  <el-menu router :default-active="$route.path" :collapse="isCollapse">
    <el-menu-item style="alignment: left;" align="left" v-for="item in menuContent" :index="item.menu_url" :key="item.url">
      <template>
        <i class="el-icon" v-html="item.menu_icon"></i>
      </template>
      <span slot="title">{{item.menu_name}}</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
  export default {
    data () {
      return {
        menuContent: [],
        isCollapse: false
      }
    },
    created () {
      window.addEventListener('resize', this.setMenu)
      this.menuContent=this.$util.fetch('menus')
    },
    mounted () {
      this.setMenu()
      this.menuContent=this.$util.fetch('menus')
    },
    methods: {
      handleOpen (key, keyPath) {
        console.log(key, keyPath)
      },
      handleClose (key, keyPath) {
        console.log(key, keyPath)
      },
      setMenu () {
        this.$nextTick(
          () => {
            if (document.documentElement.clientWidth < 850) {
              this.isCollapse = true
            } else {
              this.isCollapse = false
            }
          }
        )
      },
    }

  }
</script>

<style scoped>
  .el-menu-item.is-active >>> path {
    fill: #409EFF;
  }

  .el-menu-item >>> path {
    fill: #909399;
  }

  .el-menu-item >>> svg {
    width: 30px;
    height: 20px
  }
</style>



// WEBPACK FOOTER //
// src/components/aside/menu.vue